import License from "./licenses";
import UnexpectedError from "./unexpectedError";

export const resolvers = {
	Query: {
		...License.queryResolvers,
	},
};

export const typeDefs = [
	License.typeDefs, // the first added type
	UnexpectedError.typeDefs,
];
